export function toFiniteNumber(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

/** Same retail transform as OpenEmsMonthlyRatesWidget on /b2b. */
export function transformDamToRetailUahPerKwh(damUahPerKwh) {
  const parsed = toFiniteNumber(damUahPerKwh);
  if (parsed == null) return null;
  return 1.2 * (parsed + 3.5);
}

export function getCurrentDamRetailUahPerKwhFromLandingTotals(data) {
  if (!data?.ok || !data?.dam?.configured) return null;

  const useImportWeightedDam = data.exportScope === 'device' || data.exportScope === 'huawei';
  const currentDam =
    useImportWeightedDam && toFiniteNumber(data.dam.currentMonthDeviceImportWeightedAvgDamUahPerKwhMtd) != null
      ? toFiniteNumber(data.dam.currentMonthDeviceImportWeightedAvgDamUahPerKwhMtd)
      : toFiniteNumber(data.dam.currentAvgUahPerKwh);

  return transformDamToRetailUahPerKwh(currentDam);
}

export function getPortPriceUahPerKwh(port) {
  const priceUah = Number(port?.costPerKwt) / 100;
  return Number.isFinite(priceUah) && priceUah > 0 ? priceUah : null;
}

export function isPortCheaperThanDamPlusUah(port, damRetailUahPerKwh, extraUah = 7) {
  const portPrice = getPortPriceUahPerKwh(port);
  if (portPrice == null || damRetailUahPerKwh == null) return false;
  return portPrice < damRetailUahPerKwh + extraUah;
}

/** Cheapest-only map filter: bottom share of 220-km ports by costPerKwt (no Open EMS). */
export const KM220_CHEAPEST_ONLY_PERCENT = 40;

export function filterKm220LowestPricePercent(ports, lowestPercent = KM220_CHEAPEST_ONLY_PERCENT) {
  if (!Array.isArray(ports) || lowestPercent <= 0) return [];

  const candidates = ports.filter(port => getPortPriceUahPerKwh(port) != null);
  if (candidates.length === 0) return [];

  const sorted = [...candidates].sort((a, b) => getPortPriceUahPerKwh(a) - getPortPriceUahPerKwh(b));
  const takeCount = Math.max(1, Math.ceil((sorted.length * lowestPercent) / 100));
  const cutoffPrice = getPortPriceUahPerKwh(sorted[takeCount - 1]);

  return candidates.filter(port => getPortPriceUahPerKwh(port) <= cutoffPrice);
}
